 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3bf748c2","1":"commons","2":"862d6644","3":"db7134aa903e19fa27fcd435905e13960724bb54","4":"styles","5":"91878e01ebd362eb1f51608e7048cd484e50ae56","6":"a9b2e3e6dadc4c163c23ca71de2c551895ea8f3f","7":"framework","8":"38b4388c43eb02a00766ec71504eecf73194715c","9":"b77925a204b47dfb62f0759bfe0235b1cff26f54","10":"551c0a0e1c8787cc314d9159f4c8b1add759575b","11":"ef624002aa752d60ded5541c9fa97b42c21f381b","12":"1691de61182c64f3ef0c28b94df341d74b67c581","13":"component---src-pages-home-jsx","16":"component---src-pages-404-js","17":"component---src-pages-blog-details-js","18":"component---src-pages-category-1-jsx","19":"component---src-pages-category-2-jsx","20":"component---src-pages-category-3-jsx","21":"component---src-pages-ds-details-jsx","22":"component---src-pages-ds-jsx","23":"component---src-pages-high-notes-jsx","24":"component---src-pages-highnotes-category-jsx","25":"component---src-pages-index-js","26":"component---src-pages-login-jsx","27":"component---src-pages-resource-details-js","28":"component---src-pages-resource-jsx","29":"component---src-pages-resources-jsx","30":"component---src-pages-search-jsx","31":"component---src-pages-showall-jsx","32":"component---src-pages-uma-jsx","33":"component---src-pages-umbi-jsx","34":"component---src-pages-umc-jsx","35":"component---src-pages-umd-jsx","36":"component---src-pages-uml-jsx","37":"component---src-templates-blogpost-js"}[chunkId]||chunkId) + "-" + {"0":"841b973c5a2d1b89a2cc","1":"0a761fcb7b7653a44f00","2":"d5237af01f3e5767ca99","3":"dd6b04d49761fc071158","4":"08bc34de4ea872a98d93","5":"59f25fd3a3211caedda8","6":"7a3f6a576dd01e9c0830","7":"c6eda2073bee03fea079","8":"dcd29d659fdfb68bb578","9":"d40acdc9aeeb1dcc0350","10":"b78212c1d636cc22fc15","11":"1d930c44421bc6dd3749","12":"7a40d0bb639f78b6ccbe","13":"a168deb78cd659ae89d6","16":"6dfe35b7e5359abff32e","17":"323dc209b53bddad059c","18":"82e5c096e3c0fa6895ce","19":"355985bbe026c2853b47","20":"80d3a569fa086c89d681","21":"ed5c2a32f5db5c9f456c","22":"3f367a953e43b67ba822","23":"857e896b3112c0b14ea6","24":"274260463daa2cb730ce","25":"7703671a1b555bba26bb","26":"7143d459127de44e69bd","27":"49106dbdbe01f7ff5d29","28":"e32d3b584ee93eebd938","29":"9d07e4077cdb98b76f57","30":"9464eae6dd1c6562385f","31":"8deb72f214b103fc7e82","32":"c48aa8562ce0da18313d","33":"109202eb9efcc8421ac7","34":"a14bbec7e2c87696b9a2","35":"a3de78447731c607c4f8","36":"a5f7121eeeef711f6c08","37":"aac91dcd330a02b1b8ba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"3bf748c2","1":"commons","2":"862d6644","3":"db7134aa903e19fa27fcd435905e13960724bb54","4":"styles","5":"91878e01ebd362eb1f51608e7048cd484e50ae56","6":"a9b2e3e6dadc4c163c23ca71de2c551895ea8f3f","7":"framework","8":"38b4388c43eb02a00766ec71504eecf73194715c","9":"b77925a204b47dfb62f0759bfe0235b1cff26f54","10":"551c0a0e1c8787cc314d9159f4c8b1add759575b","11":"ef624002aa752d60ded5541c9fa97b42c21f381b","12":"1691de61182c64f3ef0c28b94df341d74b67c581","13":"component---src-pages-home-jsx","16":"component---src-pages-404-js","17":"component---src-pages-blog-details-js","18":"component---src-pages-category-1-jsx","19":"component---src-pages-category-2-jsx","20":"component---src-pages-category-3-jsx","21":"component---src-pages-ds-details-jsx","22":"component---src-pages-ds-jsx","23":"component---src-pages-high-notes-jsx","24":"component---src-pages-highnotes-category-jsx","25":"component---src-pages-index-js","26":"component---src-pages-login-jsx","27":"component---src-pages-resource-details-js","28":"component---src-pages-resource-jsx","29":"component---src-pages-resources-jsx","30":"component---src-pages-search-jsx","31":"component---src-pages-showall-jsx","32":"component---src-pages-uma-jsx","33":"component---src-pages-umbi-jsx","34":"component---src-pages-umc-jsx","35":"component---src-pages-umd-jsx","36":"component---src-pages-uml-jsx","37":"component---src-templates-blogpost-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"55d48b3789c6866c15f1","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
